import http from '@/utils/request';

// 查询应用管理列表
export function getApp(query) {
  return http.request({
    url: '/mro/webLayout/restful/list',
    method: 'get',
    params: query,
  });
}

// 获取文章
export function getArticle(query) {
  return http.request({
    url: '/mro/privacy/restful/list',
    method: 'get',
    params: query,
  });
}
